<template>
  <div>
    <div class="style-china fw">
      <style-image v-for="item in gd3" :key="item.artist_id"
          :artistData="item" v-on:click="showZoomPortfolio"  />
    </div>
    <div class="china-twocol">
      <div class="style-china mr">
        <style-image v-for="item in galleryData" :key="item.artist_id"
          :artistData="item" v-on:click="showZoomPortfolio"  />
      </div>
      <div class="style-china">
        <style-image v-for="item in gd2" :key="item.artist_id"
          :artistData="item" v-on:click="showZoomPortfolio"  />
      </div>
    </div>
    
  </div>
</template>

<script>
import StyleImage from '@/components/widgets/StyleImageHome.vue'

export default {
  components: {
    StyleImage
  },
  props: {
    gallery: Object
  },
  data () {
    return {
      loaded: false,
      galleryData:[],
      gd2: [],
      gd3:[]
    }
  },
  created () {
    if(this.gallery){
      this.init()
    }
    
  },
  mounted () {
    window.addEventListener('resize', this.handleSize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleSize)
  },
  methods: {
    async init () {
      this.loaded = false
      if(this.gallery.gallery_id){
        
        let gd = await this.$store.dispatch('fetchGalleryData', this.gallery.gallery_id)
        if(gd) {
          await this.$store.dispatch('fetchArtists')
          let artists = this.$store.getters.nonExcludedArtists.filter(el => el.artist_id)
          let lang = this.$store.state.lang.toLowerCase()
          artists = artists.filter(el => { return  !el.hiddens.includes(lang) })
          
          gd = gd.filter(el => artists.find(al => al.artist_id === el.artist_id))
          gd.sort((el, el1) => { return el.rnd - el1.rnd })
          this.galleryData = gd.slice(11, 15)
          this.gd2 = gd.slice(15, 19)
          this.gd3 = gd.slice(19, 21)
          this.loaded = true
        }
      }
      
    },
    showZoomPortfolio (artist) {
      this.$ixr.push('/artists/' + artist.portfolio_url)
    }
  },
  watch: {
    gallery () {
      if(this.gallery){
        this.init()
      }
    }
  }
}
</script>

<style scoped>

.china-twocol{
  display:flex;

}

.style-china{
  display:flex;
  flex-direction:column;
  width:48.5%;
}

.style-china.fw{
  width:100%;
}

.style-china.mr{
  margin-right:3%;
}

.style-china .imdiv{
  position:relative;
  margin-bottom:12px;
}



</style>